import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { Layout } from "./components/Layout";
import { AdminRoute } from "./components/AdminRoute";
import { DataCacheProvider } from "./contexts/DataCacheContext";
import { Login } from "./pages/Login";
import { Download } from "./pages/Download";
import { Generate } from "./pages/Generate";
import { Jobs } from "./pages/Jobs";
import { Library } from "./pages/Library";
import { Dashboard } from "./pages/admin/Dashboard";
import { Users } from "./pages/admin/Users";
import { AllJobs } from "./pages/admin/AllJobs";
import { Voices } from "./pages/admin/Voices";

function ProtectedRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-indigo-500 border-t-transparent" />
          <p className="text-slate-500 text-sm">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DataCacheProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/generate" element={<Generate />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/library" element={<Library />} />

          {/* Admin routes */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <Users />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/jobs"
            element={
              <AdminRoute>
                <AllJobs />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/voices"
            element={
              <AdminRoute>
                <Voices />
              </AdminRoute>
            }
          />

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/generate" replace />} />
        </Route>
      </Routes>
    </DataCacheProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/download" element={<Download />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
